import BaseCardBehavior from './BaseCardBehavior';
import { ICardsState } from '../ICardState';
import CardStateHelper from '../CardStateHelper';
import { IGameState } from 'State/Game/IGameState';
import { CardState } from 'Prototype/Level/Card/CardState';

export default class JokerPreBoosterCardBehavior extends BaseCardBehavior {
    public isPlayable(state: ICardsState) {
        return state.inStack.some(cardID => cardID === this.cardID);
    }

    public play(state: IGameState): IGameState {
        const currentCardState = CardStateHelper.getCardState(state.levelState.cardsState, this.cardID);
        if (currentCardState === CardState.IN_STACK) {
            return CardStateHelper.foldStackCard(state, this.cardID);
        }
        return state;
    }
}
